/*
 * Reliq blog day / dark toggle.
 * Default is dark. The choice is stored in localStorage and applied to
 * <html data-theme="..."> so it survives navigation between blog pages.
 * A no-flash inline script in the section sets the attribute before paint;
 * this file only wires up the toggle button(s).
 */
(function () {
  var STORAGE_KEY = 'reliq-theme';
  var root = document.documentElement;

  function currentTheme() {
    return root.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function applyTheme(theme) {
    root.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* storage may be unavailable (private mode); fail quietly */
    }
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      var isLight = theme === 'light';
      btn.setAttribute('aria-pressed', String(isLight));
      btn.setAttribute(
        'aria-label',
        isLight ? 'Switch to dark mode' : 'Switch to day mode'
      );
    });
  }

  // Sync button state to whatever the no-flash script already set.
  applyTheme(currentTheme());

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-theme-toggle]');
    if (!btn) return;
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  // Copy-link share button.
  document.addEventListener('click', function (event) {
    var copyBtn = event.target.closest('[data-share-copy]');
    if (!copyBtn) return;
    var url = copyBtn.getAttribute('data-url') || window.location.href;
    var done = function () {
      copyBtn.classList.add('is-copied');
      setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
    }
  });

  // Tuck the toggle away while the footer is on screen, so it never
  // sits on top of the footer.
  function watchFooter() {
    var footer = document.querySelector('.footer, footer, [class*="footer"]');
    if (!footer || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        var overFooter = entries[0].isIntersecting;
        document.querySelectorAll('.reliq-toggle').forEach(function (btn) {
          btn.classList.toggle('reliq-toggle--tucked', overFooter);
        });
      },
      { rootMargin: '0px' }
    );
    io.observe(footer);
  }

  if (document.readyState !== 'loading') {
    watchFooter();
  } else {
    document.addEventListener('DOMContentLoaded', watchFooter);
  }
})();
